// extracted by mini-css-extract-plugin
export default {"navList":"NavList_navList__UCNwL","active":"NavList_active__vfuEH"};